// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Viva_containerPrincipal__tCF8Z","divPrincipal":"Viva_divPrincipal__NMyg8","divTextos":"Viva_divTextos__kwd8c"};